export enum Direction {
  NO_GUIDANCE = 0,
  LARGER = 1,
  SMALLER = 2,
}
